import create, { SetState, StateCreator, StoreApi } from "zustand";

interface IMeasuresStore {
  clearStore: () => void;
  measureName: any;
  setMeasureName: (x: any) => void;
  selectedProvider: any;
  setSelectedProvider: (x: any) => void;
  selectedHealthPlan: any;
  setSelectedHealthPlan: (x: any) => void;
  selectedPCPVendor: any;
  setSelectedPcpVendor: (x: any) => void;
  patientIds: any;
  patientIdsHandler: (x: any) => void;
  comingFromMeasures: boolean;
  memberPageNavigationHandler: (x: boolean) => void;
  options: any;
  setOptions: (x: any) => void;
  pcpVendorOptions: any;
  setPcpVendorOptions: (x: any) => void;
  healthPlanOptions: any;
  setHealthPlanOptions: (x: any) => void;
  appliedProvider: any;
  setAppliedProvider: (x: any) => void;
  selectedYear: any;
  setSelectedYear: (x: any) => void;
  yearSelectedInCareGaps: any;
  setYearSelectedInCareGaps: (x: any) => void;
  comingFromMeasuresReport: boolean;
  setComingFromMeasuresReport: (x: boolean) => void;
}

let store: StateCreator<IMeasuresStore, [], [], IMeasuresStore> | StoreApi<IMeasuresStore> = (set: SetState<IMeasuresStore>) => ({
  measureName: null,
  setMeasureName: (x) => {
    set(() => ({ measureName: x }));
  },
  selectedProvider: [],
  setSelectedProvider: (x) => {
    set(() => ({ selectedProvider: x }));
  },
  selectedHealthPlan: [],
  setSelectedHealthPlan: (x) => {
    set(() => ({ selectedHealthPlan: x }));
  },
  selectedPCPVendor: [],
  setSelectedPcpVendor: (x) => {
    set(() => ({ selectedPCPVendor: x }));
  },
  options: [],
  setOptions: (x) => {
    set(() => ({ options: x }));
  },
  pcpVendorOptions: [],
  setPcpVendorOptions: (x) => {
    set(() => ({ pcpVendorOptions: x }));
  },
  healthPlanOptions: [],
  setHealthPlanOptions: (x) => {
    set(() => ({ healthPlanOptions: x }));
  },
  patientIds: [],
  patientIdsHandler: (x) => {
    set(() => ({ patientIds: x }));
  },
  comingFromMeasures: false,
  memberPageNavigationHandler: (x) => {
    set(() => ({ comingFromMeasures: x }));
  },
  appliedProvider: false,
  setAppliedProvider: (x) => {
    set(() => ({ appliedProvider: x }));
  },
  selectedYear: null,
  setSelectedYear: (x) => {
    set(() => ({ selectedYear: x }));
  },
  yearSelectedInCareGaps: null,
  setYearSelectedInCareGaps: (x) => {
    set(() => ({ yearSelectedInCareGaps: x }));
  },
  comingFromMeasuresReport: false,
  setComingFromMeasuresReport: (status) => {
    set(() => ({ comingFromMeasuresReport: status }));
  },
  clearStore: () => {
    set(() => ({ selectedProvider: [] }));
    set(() => ({ selectedHealthPlan: [] }));
    set(() => ({ selectedPCPVendor: [] }));
    set(() => ({ patientIds: [] }));
    set(() => ({ comingFromMeasures: false }));
    set(() => ({ options: [] }));
    set(() => ({ pcpVendorOptions: [] }));
    set(() => ({ healthPlanOptions: [] }));
    set(() => ({ appliedProvider: [] }));
    set(() => ({ selectedYear: null }));
    set(() => ({ yearSelectedInCareGaps: null }));
    set(() => ({ comingFromMeasuresReport: false }));
    set(() => ({ measureName: null }));
  },
});

export const useMeasuresStore = create(store);
